import React from "react";
import "../../index.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2026 Orion Scaled. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
